import { Button, type ButtonProps } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import SignUpLink from '@/components/Auth/SignUpLink'

export default function SignupButton({
  text = 'Sign Up',
  ...props
}: {
  text?: string
} & ButtonProps): JSX.Element | null {
  const router = useRouter()

  return (
    <SignUpLink href={router.asPath}>
      <Button {...props}>{text}</Button>
    </SignUpLink>
  )
}
